import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation CreateContentWriterRequest($name: String!, $email: String!, $message: String!) {
    createContentWriterRequest(data: { name: $name, email: $email, message: $message }) {
      id
    }
  }
`

export interface CreateContentWriterRequestInput {
  name: string
  email: string
  message: string
}

export interface CreateContentWriterRequestOutput {
  createContentWriterRequest: {
    id: string
  }
}

export const useCreateContentWriterRequest = () =>
  useMutation<CreateContentWriterRequestOutput, CreateContentWriterRequestInput>(mutation)
